import React, { forwardRef, useEffect, useState } from 'react';
import Nav from '../nav';
import Header from '../../../common/header/header';
import { MultiSelect, rem, Button, Select, Group, Text } from '@mantine/core';
import Paginate from 'react-paginate';
import LoadingImage from '../../../assets/media/loader.gif';
import { IconCalendar, IconChevronDown } from '@tabler/icons-react';
import { DatePickerInput } from '@mantine/dates';
import { Link, useLocation } from 'react-router-dom';
import { pdf } from '../../../api/baseUrl';
import axios from 'axios';
import { IconSearch } from '@tabler/icons-react';

function Home() {
  const [company, setCompany] = useState();
  const [provider, setProvider] = useState();
  const [type, setType] = useState();
  const [sector, setSector] = useState();
  const [date, setDate] = useState([null, null]);
  const icon = <IconChevronDown size={16} />;
  const [filter, setFilter] = useState([]);
  // const [date, setDate] = useState([null, null]);
  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [check, setCheck] = useState(false);
  const indexOfLastPost = (currentPage + 1) * postsPerPage;
  const indexOfFirstPost = currentPage * postsPerPage;
  const currentPosts = records.slice(indexOfFirstPost, indexOfLastPost);
  const [initialFilings, setInitialFilings] = useState([]);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const calendaricon = (
    <IconCalendar style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );

  const SelectItem = forwardRef(({ image, label, name, ...others }, ref) => (
    <div ref={ref} {...others}>
      <Group noWrap>
        {/* <Avatar src={image} size="sm" /> */}
        <div>
          <Text size="sm">{label}</Text>
          <Text size="xs" opacity={0.65}>
            {name}
          </Text>
        </div>
      </Group>
    </div>
  ));

  useEffect(() => {
    fetch(`https://www.cms.akseerresearch.com/api/sellsideresearch`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        // Authorization: `Bearer ${cookies?.accessToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // setFilings(data.data);
        setFilter(data.filter);
        setRecords(data.data);
        setCheck(true);
        if (initialFilings.length === 0) {
          setInitialFilings(data.data);
        }
        setIsLoading(true);
        // setCheck(true);
      })
      .catch((error) => {
        console.error('Error fetching data:', error); // Debugging
      });
  }, []);

  const handleSubmit = () => {
    setRecords([]);
    setIsLoading(false);

    axios
      .post(`https://www.cms.akseerresearch.com/api/sellsideresearch`, {
        company: company,
        type: type,
        sector: sector,
        provider: provider,
        date: date,
      })
      .then((response) => {
        let filteredData = response.data;
        setRecords(filteredData);
        setIsLoading(true);
        setCurrentPage(0);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };

  const handlePostsPerPage = (e) => {
    setCurrentPage(0);
    setPostsPerPage(e.target.value);
  };

  const paginate = ({ selected }) => {
    setCurrentPage(selected);
  };

  const resetInputField = () => {
    setType([]);
    setCompany([]);
    setProvider([]);
    setSector([]);
    setDate([null, null]);
    setRecords(initialFilings);
    setCurrentPage(0);
  };

  return (
    <>
      <Header />
      <div className="investment-main analyst">
        <div className="row investmentboxed" style={styles.navWidth}>
          <Nav nopadding={true} />
        </div>
      </div>
      <div className="research-report-main">
        <div className="container container_box">
          {Object.keys(filter).length ? (
            <>
              <div className="research-select-field">
                <div className="research-company-field">
                  {/* <MultiSelect
                    data={filter.company}
                    searchable
                    rightSection={icon}
                    label="Company"
                    placeholder="Select Company"
                    value={company}
                    onChange={setCompany}
                  /> */}
                  <Select
                    placeholder="Search..."
                    itemComponent={SelectItem}
                    data={filter.company}
                    value={company}
                    onChange={setCompany}
                    searchable
                    clearable
                    label="Company"
                    className="search-field-stroke"
                    maxDropdownHeight={400}
                    nothingFound="Not Found"
                    filter={(value, item) =>
                      item.label
                        .toLowerCase()
                        .includes(value.toLowerCase().trim())
                    }
                    rightSection={icon}
                    rightSectionWidth={30}
                    styles={{ rightSection: { pointerEvents: 'none' } }}
                  />
                </div>
                <div className="research-company-field">
                  <MultiSelect
                    data={filter.provider}
                    searchable
                    rightSection={icon}
                    placeholder="Select Provider"
                    label="Provider"
                    value={provider}
                    onChange={setProvider}
                  />
                </div>
              </div>
              <div className="research-select-field mt-3 research-second-box">
                <div className="research-second-line">
                  <MultiSelect
                    data={filter.type}
                    searchable
                    rightSection={icon}
                    placeholder="Select Type"
                    label="Type"
                    value={type}
                    onChange={setType}
                  />
                </div>
                <div className="research-second-line">
                  <MultiSelect
                    data={filter.sector}
                    searchable
                    rightSection={icon}
                    placeholder="Select Sector"
                    label="Sector"
                    value={sector}
                    onChange={setSector}
                  />
                </div>
                <div className="research-second-line">
                  <DatePickerInput
                    clearable
                    type="range"
                    value={date}
                    onChange={setDate}
                    valueFormat="DD MMM, YYYY"
                    placeholder="Select Date Range"
                    label="Date Range"
                    className="news-date-picker"
                    mx="auto"
                    icon={<IconCalendar size="1.1rem" stroke={1.5} />}
                  />
                </div>
                <Button className="research-search-btn" onClick={handleSubmit}>
                  Search
                </Button>
                <Button
                  className="research-search-btn clear-btn-stl"
                  onClick={resetInputField}
                >
                  Clear
                </Button>
              </div>
            </>
          ) : (
            ''
          )}

          {isLoading ? (
            <>
              <div className="excel-btn research-number-select">
                <div className="select_drop">
                  <select
                    className="selectpicker"
                    value={postsPerPage}
                    onChange={handlePostsPerPage}
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>
              </div>
              <div className="research-report-tbl ask-table-format research-report-home">
                <table className="table table-responsive">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Provider</th>
                      <th>Date</th>
                      <th>Company</th>
                      <th>Sector</th>
                      <th>Type</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPosts.length ? (
                      currentPosts.map((value, index) => (
                        <tr>
                          <td>{value.name}</td>
                          <td>{value.vendor}</td>
                          <td>{value.date}</td>
                          <td>
                            <span className="research-company-tag">
                              {value.company}
                            </span>
                          </td>
                          <td>
                            <span className="cementtext">{value.sector}</span>
                          </td>
                          <td>
                            <span className="companytext">{value.type}</span>
                          </td>
                          <td className="center-align">
                            <Link
                              to={{ pathname: `${value.path}` }}
                              target="_blank"
                              download
                            >
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: pdf,
                                }}
                              />
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} className="text-center">
                          {check ? 'No Record Found' : 'Loading...'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {currentPosts.length ? (
                <div className="dropdown-pagination">
                  <Paginate
                    onPageChange={paginate}
                    pageCount={Math.ceil(records.length / postsPerPage)}
                    previousLabel={'Prev'}
                    nextLabel={'Next'}
                    containerClassName={'pagination'}
                    pageLinkClassName={'page-number'}
                    previousLinkClassName={'page-number'}
                    nextLinkClassName={'page-number'}
                    activeLinkClassName={'active'}
                    forcePage={currentPage}
                  />
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <>
              <div
                style={{ width: '100%', height: '100%', color: '#426fd7' }}
                className="main-loader d-flex flex-column justify-content-center align-items-center"
              >
                <img src={LoadingImage} style={{ height: '500px' }} />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

const styles = {
  companylogo: {
    width: '280px',
    float: 'right',
  },
  navWidth: {
    width: '100%',
    fontSize: '14px',
    margin: 'auto',
    marginBottom: '10px',
    justifyContent: 'space-between',
  },
  companyname: {
    width: '100%',
    fontSize: '14px',
    justifyContent: 'space-between',
    marginLeft: '0px',
    marginRight: '0px',
  },
};

export default Home;
